export var dataHooks = {
  title: 'google-preview-title',
  url: 'google-preview-url',
  description: 'google-preview-description'
};